
import Vue from 'vue';
import Component from 'vue-class-component';
import {namespace} from 'vuex-class';
import {IOnOffHandlers} from 'bonomo/dist';
import {IShortInvoice} from '@/model/Invoice/invoiceInterfaces';
import Datim from '@/components/shared/Datim.vue';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import CreateButton from '@/components/shared/CreateButton.vue';
import {PAGINATION_DEFAULT_PER_PAGE, PAGINATION_FIRST_PAGE, PAGINATION_PER_PAGE_OPTIONS} from '@/constants/pagination';
import {UrlHelper} from '@/helpers/UrlHelper';

const invoiceModule = namespace('invoiceModule');

@Component({
  components: {Datim, PaginationBar, CreateButton},
})
export default class InvoiceList extends Vue {
  @invoiceModule.Getter('invoiceList')
  protected invoiceList!: IShortInvoice[];
  @invoiceModule.Getter('currentPage')
  protected currentPage!: number;
  @invoiceModule.Getter('lastPage')
  protected lastPage!: number;
  @invoiceModule.Getter('total')
  protected total!: number;

  protected readonly perPageOptions: number[] = PAGINATION_PER_PAGE_OPTIONS;
  protected loading: boolean = false;
  protected statusFilter: string = '';
  protected search: string = '';
  protected localPerPage: number = PAGINATION_DEFAULT_PER_PAGE;
  private searchTimer: any = null;
  private subscribes: IOnOffHandlers = {};

  get oldInvoicesUrl(): string {
    return UrlHelper.mayorInvoices();
  }

  protected headers = [
    {text: '#', value: 'id', sortable: false},
    {text: 'Customer', value: 'customer', sortable: false},
    {text: 'Service Provider', value: 'service_provider', sortable: false},
    {text: 'Total', value: 'grand_total', sortable: false},
    {text: 'Status', value: 'status', sortable: false},
    {text: 'PDF', value: 'has_pdf', sortable: false},
    {text: 'Date', value: 'created_at', sortable: false},
    {text: '', value: 'actions', sortable: false, align: 'right'},
  ];

  created() {
    this.subscribes = (this as any).$ons({
      'backend.call.OK.invoicesLoaded': this.onLoaded,
      'backend.call.KO': this.onError,
    });
    this.loadData(PAGINATION_FIRST_PAGE);
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  protected loadData(page: number) {
    this.loading = true;
    const filters: any = {page, per_page: this.localPerPage};
    if (this.statusFilter) {
      filters.status = this.statusFilter;
    }
    if (this.search) {
      filters.search = this.search;
    }
    this.$store.dispatch('invoiceModule/fetchInvoices', filters);
  }

  protected setStatusFilter(value: string) {
    this.statusFilter = value;
    this.loadData(PAGINATION_FIRST_PAGE);
  }

  protected onPageChange(page: number) {
    this.loadData(page);
  }

  protected onPerPageChange(perPage: number) {
    this.localPerPage = perPage;
    this.loadData(PAGINATION_FIRST_PAGE);
  }

  protected onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadData(PAGINATION_FIRST_PAGE), 400);
  }

  protected onClearSearch() {
    this.search = '';
    this.loadData(PAGINATION_FIRST_PAGE);
  }

  protected statusColor(status: string): string {
    if (status === 'invoice_paid') return 'green';
    if (status === 'invoice_awaiting_payment') return 'orange';
    return 'grey';
  }

  private onLoaded() {
    this.loading = false;
  }

  private onError() {
    this.loading = false;
  }
}
